



















import Vue from 'vue'
import PageTitle from '@/components/atoms/PageTitle.vue'
import SimpleLoader from '@/components/atoms/SimpleLoader.vue'
import SpecialItem from '@/components/molecules/SpecialItem.vue'
import SpecialItemUnit from '@/components/molecules/SpecialItemUnit.vue'

export default Vue.extend({
  name: 'BenefitsList',
  components: {
    PageTitle,
    SimpleLoader,
    SpecialItem,
    SpecialItemUnit
  },
  computed: {
    isPageLoading(): boolean {
      return this.$state.benefits.isBenefitsLoading
    },
    benefits(): object[] {
      return this.$state.benefits.benefits
    }
  },
  mounted() {
    this.$store.dispatch('benefits/fetchBenefits', { limit: 50 })
  }
})
